import { Component, OnInit } from "@angular/core";
import { UserInfoService } from "../../services/user-info.service";

@Component({
    selector: "app-unauthorized",
    templateUrl: "./unauthorized.component.html",
    standalone: false
})
export class UnauthorizedComponent implements OnInit {

    constructor(private userInfoService: UserInfoService) { /**/ }

    ngOnInit() {
        return;
    }

    reset() {
        // Only remove OIDC-related keys, not all localStorage
        Object.keys(localStorage)
            .filter(key => key.startsWith("0-") || key.startsWith("oidc."))
            .forEach(key => localStorage.removeItem(key));
        try {
            this.userInfoService.logout();
        }
        catch (e) {
            window.location.href = "https://palliativregistret.se";
        }
    }
}
